/* eslint-disable no-unused-vars */
import axios from "axios";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useAuth } from "../../context/auth";

const CurrentLocation = ({
  setDetails = () => {},
  setTypehState,
  setAddCurrentAdd = () => {},
  setTypehCountry = () => [],
}) => {
  const [location, setLocation] = useState({ lat: null, lng: null });
  const [address, setAddress] = useState("");
  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);
  const [amenity, setAmenity] = useState("");
  const [road, setRoad] = useState("");
  const [neighbourhood, setNeighbourhood] = useState("");
  const [stateDistrict, setStateDistrict] = useState("");
  const [state, setState] = useState("");
  const [postcode, setPostcode] = useState("");
  const [country, setCountry] = useState("");
  const [auth] = useAuth();
  const [userId, setUserId] = useState(auth?.user.id);

  const handleClose = () => {
    setShow(false);
  };

  const getLocation = () => {
    setShow(true);
    if (!navigator.geolocation) {
      setError("Geolocation is not supported by your browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setLocation({ lat: latitude, lng: longitude });
        setError(null);
        fetchAddress(latitude, longitude);
      },
      (err) => {
        setError(err.message);
      }
    );
  };

  const fetchAddress = async (lat, lon) => {
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
      );
      setAmenity(
        response?.data?.address?.amenity ||
          response?.data?.address?.suburb ||
          ""
      );
      setRoad(
        response?.data?.address?.road || response?.data?.address?.county || ""
      );
      setNeighbourhood(response?.data?.address?.neighbourhood || "");
      setStateDistrict(response?.data?.address?.state_district || "");
      setState(response?.data?.address?.state || "");
      setPostcode(response?.data?.address?.postcode || "");
      setAddress(response?.data?.display_name || "");
      setCountry(response?.data?.address?.country || "");
      setTypehState([response?.data?.address?.state]);
      setTypehCountry([response?.data?.address?.country]);
    } catch (error) {
      setError("Error fetching address.");
    }
  };

  const handleConfirmAddress = () => {
    setDetails({
      customer_id: userId,
      contact_person_name: auth?.user?.name,
      phone: auth?.user?.phone,
      address_type: "",
      c_code: auth?.user.c_code,
      state: state || "",
      city: stateDistrict || "",
      zip: postcode || "",
      landmark: neighbourhood || "",
      country: country || "",
      address: `${amenity || ""}, ${road || ""}`,
    });
    setAddCurrentAdd({
      customer_id: userId,
      contact_person_name: "",
      c_code: "",
      phone: "",
      address_type: "",
      country: country,
      state: state,
      city: stateDistrict,
      zip: postcode,
      landmark: neighbourhood,
      address: `${amenity || ""}, ${road || ""}`,
    });
    setShow(false);
  };

  return (
    <>
      <button type="button" onClick={getLocation}>
        <i className="fa-solid fa-map-marker-alt"></i> Use my current location
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="custom-login location-popup"
        backdropClassName="location-backdrop"
      >
        {!address && (
          <>
            {!error && (
              <Modal.Header closeButton>
                <h2>Detecting location, please wait...</h2>
              </Modal.Header>
            )}
            {error && (
              <Modal.Header closeButton>
                <h2>Oops...</h2>
              </Modal.Header>
            )}
            <Modal.Body>
              {error && <p className="mt-2 text-red-500">{error}</p>}
            </Modal.Body>
          </>
        )}
        {address && (
          <>
            <Modal.Header closeButton>
              <h2>Location found</h2>
            </Modal.Header>
            <Modal.Body>
              <p>
                {amenity}, {road}, <br /> {neighbourhood}
                <br />
                {stateDistrict}, {state}, {postcode}
              </p>
            </Modal.Body>
            <Modal.Footer className="location-btn">
              <button type="button" onClick={handleConfirmAddress}>
                Confirm Address
              </button>
              <button type="button" onClick={() => setShow(false)}>
                Cancel
              </button>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

export default CurrentLocation;
